if (document.querySelector(".product__description .description")) {
    let description = document.querySelector(".product__description .description");
    let totalHeight = 0;

    // document.querySelectorAll(".product__description .description > *").forEach((elem) => {
    //   totalHeight = totalHeight + elem.clientHeight;
    // })

    // using scrollHeight instead of summing child clientHeights (since when the content is string it will be taken into account)
    totalHeight = description.scrollHeight;
    
    if (description.clientHeight < totalHeight) {
      document.querySelector(".product__description--toggle").addEventListener("click", function() {
        this.parentNode.classList.toggle("product__description--large")
        this.querySelector("span:first-of-type").classList.toggle("hidden");
        this.querySelector("span:last-child").classList.toggle("hidden");
      })
    } else {
      document.querySelector(".product__description--toggle").classList.add("hidden")
    }
  }
  
  document.querySelector(".product-form__sizes").addEventListener("click", (event) => {
    if (event.target.classList.contains("button-size")) {
      document.querySelector(".product-form__sizes").parentNode.querySelector(".variant-selected").classList.remove("hidden");
      document.querySelector(".product-form__sizes").parentNode.querySelector(".variant-selected-plus").classList.add("hidden");
    }
  })
  
  if(document.querySelectorAll(".product__info-container details")) {
    document.querySelectorAll(".product__info-container details").forEach( (details) => {
      details.addEventListener("click", function() {
        if (!this.hasAttribute("open")) {
          document.querySelectorAll(".product__info-container details").forEach( (detailstoclose) => {
              if (detailstoclose.hasAttribute("open")) detailstoclose.removeAttribute("open")
          })
        }
      })
    })
  }